import { showElement, hideElement } from '/src/common/js';

const bodyRef = document.querySelector('body');
const loaderRef = document.querySelector('.loader');

export function showLoader() {
  bodyRef?.classList.add('isLoading');
  showElement(loaderRef);
}

export function hideLoader() {
  bodyRef?.classList.remove('isLoading');
  hideElement(loaderRef);
}
